import React, { useEffect, useState } from "react";
import Navigation from "../../components/Navigation";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import Constants from "../Variables/Constants";
import Loader from "../../components/Loader";
import NoData from "../../components/NoData";
import "./OrdersPage.css";
import moment from "moment";

const OrdersPage = () => {
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");
  const [orderList, setOrderList] = useState([]);
  const [payLinksByOrderId, setPayLinksByOrderId] = useState({});
  const navigate = useNavigate();

  const fetchMyOrders = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${Constants.getUrls.getMyOrders}?sort=-createdAt`,
        {
          headers: { Authorization: token },
        }
      );
      if (res.data.status === "success") {
        setOrderList(res.data.data);
        setLoading(false);
      } else {
        setLoading(false);
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error("Failed to fetch order items.");
      }
    } catch (err) {
      console.error(err);
      setLoading(false);
      toast.clearWaitingQueue();
      toast.dismiss();
      toast.error("Failed to fetch order items.", err.message);
    }
  };

  useEffect(() => {
    fetchMyOrders();
  }, []);

  const canShowPayNow = (order) => {
    const paymentStatus = order?.payment_status;
    const dueAmount = Number(order?.amount_due_now || 0);
    return (
      dueAmount > 0 &&
      (paymentStatus === "Payment Pending" ||
        paymentStatus === "Paid a 50% Deposit")
    );
  };

  const handlePayNow = async (orderId) => {
    try {
      const response = await axios.post(
        `${Constants.postUrls.payNowOrder}${orderId}`,
        {},
        {
          headers: { Authorization: token },
        }
      );

      if (response?.data?.url) {
        window.location.href = response.data.url;
      } else {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(response?.data?.message || "Unable to start payment.");
      }
    } catch (error) {
      toast.clearWaitingQueue();
      toast.dismiss();
      toast.error(error?.response?.data?.message || error.message);
    }
  };

  const copyToClipboard = async (text) => {
    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        return true;
      }
    } catch (e) {
      // fall through to legacy copy
    }

    try {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.setAttribute("readonly", "");
      textarea.style.position = "absolute";
      textarea.style.left = "-9999px";
      document.body.appendChild(textarea);
      textarea.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(textarea);
      return ok;
    } catch (e) {
      return false;
    }
  };

  const handleCopyPayNowLink = async (orderId) => {
    try {
      let url = payLinksByOrderId?.[orderId];

      if (!url) {
        const response = await axios.post(
          `${Constants.postUrls.payNowOrder}${orderId}`,
          {},
          {
            headers: { Authorization: token },
          }
        );

        url = response?.data?.url;
        if (!url) {
          toast.clearWaitingQueue();
          toast.dismiss();
          toast.error(response?.data?.message || "Unable to generate payment link.");
          return;
        }

        setPayLinksByOrderId((prev) => ({ ...(prev || {}), [orderId]: url }));
      }

      const copied = await copyToClipboard(url);
      toast.clearWaitingQueue();
      toast.dismiss();
      copied ? toast.success("Payment link copied.") : toast.error("Unable to copy payment link.");
    } catch (error) {
      toast.clearWaitingQueue();
      toast.dismiss();
      toast.error(error?.response?.data?.message || error.message);
    }
  };

  if (loading) {
    return (
      <>
        <center>
          <Loader />
        </center>
      </>
    );
  }
  console.log("orderList", orderList)
  return (
    <div>
      <Navigation />

      <div className="order-list-container">
        <div className="order-list-wrapper">
          {orderList.length === 0 && (
            <NoData
              image="https://static.vecteezy.com/system/resources/previews/014/814/239/non_2x/no-order-a-flat-rounded-icon-is-up-for-premium-use-vector.jpg"
              text=""
            />
          )}
          {orderList.map(
            (order) =>
              order.items.length > 0 && (
                <div className="order-card" key={order._id}>
                  {order.items.map((orderItem) => (
                    <Link
                      to={`/track?id=${order._id}`}
                      key={`${orderItem.product_id}-${order._id}`}
                      className="order-item-link"
                    >
                      <div className="order-item-card">
                        <div className="order-item-info">
                          {orderItem?.images &&
                            Array.isArray(orderItem?.images) &&
                            orderItem?.images?.length > 0 &&
                            orderItem?.images[0] && (
                              <img loading="lazy" 
                                className="order-item-image"
                                src={`${Constants.imgDomain}${orderItem?.images[0]}`}
                                alt={orderItem.name}
                              />
                            )}
                          <div className="order-item-details">
                            <h1 className="order-item-name">
                              {orderItem.name}
                            </h1>

                            {orderItem?.price_data && (<>
                              <div className="mt-2">
                                <h4 className="my-0"><b>Fabric Price: </b>${JSON.parse(orderItem.price_data)?.fabric_price || 0}</h4>

                                <h4 className="my-0"><b>Design Price: </b>${JSON.parse(orderItem.price_data)?.design_price || 0}</h4>

                                <h4 className="my-0"><b>Text Price: </b>${JSON.parse(orderItem.price_data)?.text_price || 0}</h4>
                              </div>
                            </>)}

                            {orderItem?.matching_bag && orderItem?.matching_bag !== "[object Object]" && (<>
                              {JSON.parse(orderItem.matching_bag)?.name && (<>
                                <h4 className="my-0"  ><b>Matching Bag </b>{JSON.parse(orderItem.matching_bag).name}</h4>
                                <h4 className="my-0"><b>Matching Bag Price: </b>${JSON.parse(orderItem.matching_bag).price || 0}</h4>
                              </>)}
                            </>)}
                            <h5>Price Per Quantity (${orderItem.price})</h5>
                            <p className="order-item-quantity">
                              Quantity: {orderItem.quantity}
                            </p>
                          </div>
                        </div>
                        <div className="order-item-price">
                          <p className="order-item-total-price">
                            ${orderItem.price * orderItem.quantity}
                          </p>
                        </div>
                      </div>
                    </Link>
                  ))}
                  <div className="d-flex justify-content-between flex-wrap w-100">
                    <div className="h5 me-2">
                      Order No: {order?.display_order_id || order?._id}
                    </div>
                    <div className="h4 me-2">
                      Return Eligible Till: {moment(order.return_date).format(
                        "DD-MMM-YYYY"
                      )}
                    </div>
                    <div className="h4 text-end">
                      <div>
                        Subtotal: ${Number(order?.subtotal || 0).toFixed(2)}
                      </div>
                      <div>
                        Shipping: ${Number(order?.shipping_amount || 0).toFixed(2)}
                      </div>
                      <div>
                        Tax: ${Number(order?.tax_amount || 0).toFixed(2)}
                      </div>
                      {(order?.ups_service_description || order?.ups_service_code) && (
                        <div>
                          UPS Service: {order?.ups_service_description && order?.ups_service_code
                            ? `${order.ups_service_description} (${order.ups_service_code})`
                            : (order?.ups_service_description || order?.ups_service_code)}
                        </div>
                      )}
                      <div>
                        Total Price: ${Number(order?.amount || 0).toFixed(2)}
                      </div>
                    </div>
                  </div>
                  <div className="order-status-container">
                    <button
                      className="order-status-button"
                      type="button"
                      onClick={() => navigate(`/track?id=${order._id}`)}
                    >
                      {order?.order_status}
                    </button>
                    {canShowPayNow(order) && (
                      <>
                        <button
                          className="order-status-button ms-2"
                          type="button"
                          onClick={() => handlePayNow(order._id)}
                        >
                          Pay Now 
                        </button>
                        <button
                          className="order-status-button ms-2"
                          type="button"
                          onClick={() => handleCopyPayNowLink(order._id)}
                        >
                          Copy Link
                        </button>
                      </>
                    )}
                  </div>
                </div>
              )
          )}
        </div>
      </div>

    </div>
  );
};

export default OrdersPage;
